import React from 'react';
import { useParams } from 'react-router-dom';
import { CenteredLoader, PublicBackground } from '@app/core';
import { useParticipation } from '@app/api';
import { TagsConfirmedParticipationHeader } from '../ParticipationSummary/components/TagsConfirmedParticipationHeader';
import { ConfirmedParticipationBottomHeader } from '../ParticipationSummary/components/ConfirmedParticipationBottomHeader';
import { ParticipationInstructionUnmoderated } from '../ParticipationSummary/components/ParticipationInstructionUnmoderated';

export const ParticipationReturnLanding = () => {
  const { id, message } = useParams();

  const { data: participation, isLoading } = useParticipation(id, {
    retry: false,
  });

  if (isLoading) {
    return (
      <PublicBackground>
        <CenteredLoader />
      </PublicBackground>
    );
  }

  if (!participation) {
    return (
      <PublicBackground>
        <CenteredLoader />
      </PublicBackground>
    );
  }

  return (
    <PublicBackground
      customContent
      tagsChildren={
        <TagsConfirmedParticipationHeader participation={participation} />
      }
      bottomChildren={
        <ConfirmedParticipationBottomHeader participation={participation} />
      }
      participation={participation}
    >
      <ParticipationInstructionUnmoderated
        participation={participation}
        message={message}
      />
    </PublicBackground>
  );
};
